"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _initializerDefineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/initializerDefineProperty.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/applyDecoratedDescriptor.js"));
var _initializerWarningHelper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/initializerWarningHelper.js"));
var _vuePropertyDecorator = require("vue-property-decorator");
var _moment = _interopRequireDefault(require("moment"));
var _product = require("@/types/product");
require("../../../../public/custom-print.css");
var _initStore = require("@/store/initStore");
var _enum = require("@/utils/enum");
var _dec, _class, _class2, _descriptor; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var ReceiptPrint = exports.default = (_dec = (0, _vuePropertyDecorator.Prop)({
  type: Object,
  default: function _default() {
    return {};
  }
}), (0, _vuePropertyDecorator.Component)(_class = (_class2 = /*#__PURE__*/function (_Vue) {
  function ReceiptPrint() {
    var _this;
    (0, _classCallCheck2.default)(this, ReceiptPrint);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ReceiptPrint, [].concat(args));
    (0, _initializerDefineProperty2.default)(_this, "data", _descriptor, _this);
    (0, _defineProperty2.default)(_this, "UnitTrans", _product.UnitTrans);
    (0, _defineProperty2.default)(_this, "totalPrice", 0);
    (0, _defineProperty2.default)(_this, "ConfigurationParam", _enum.ConfigurationParam);
    return _this;
  }
  (0, _inherits2.default)(ReceiptPrint, _Vue);
  return (0, _createClass2.default)(ReceiptPrint, [{
    key: "configurationList",
    get: function get() {
      return _initStore.configurationStore.list;
    }
  }, {
    key: "table",
    get: function get() {
      var _this2 = this;
      var data = [];
      var stt = 1;
      this.totalPrice = 0;
      this.data.products.forEach(function (product) {
        data.push((0, _objectSpread2.default)((0, _objectSpread2.default)({}, product), {}, {
          stt: stt
        }));
        stt++;
        _this2.totalPrice += product.quantity * product.product.retailPrice;
      });
      return data;
    }
  }, {
    key: "transformDate",
    get: function get() {
      if (!this.data.printDate) {
        return "--";
      }
      return (0, _moment.default)(this.data.printDate, "DD/MM/YYYY").format("[Ngày] DD [tháng] MM [năm] YYYY");
    }
  }, {
    key: "transformDateJp",
    get: function get() {
      if (!this.data.printDate) {
        return "--";
      }
      return (0, _moment.default)(this.data.printDate, "DD/MM/YYYY").format("YYYY[年] MM[月] DD[日]");
    }
  }, {
    key: "handlePrint",
    value: function handlePrint() {
      this.$htmlToPaper("print-receipt", {
        name: "_blank",
        specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
        styles: ["/custom-print.css"]
      });
    }
  }]);
}(_vuePropertyDecorator.Vue), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "data", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);